<template>
    <div v-if="data">
        <el-dialog
            :title="data.label"
            width="600px"
            :visible="show"
            :before-close="beforeClose"
            :append-to-body="true"
            @close="onCancelClick()"
        >
            <el-form ref="form" label-width="160px" label-position="right" size="small">
                <el-form-item label="Currency" prop="asset_name">
                    <div class="form-value">{{data.asset_name}}</div>
                </el-form-item>
                <el-form-item label="Address" prop="address">
                    <div class="form-value">{{data.address}}</div>
                </el-form-item>
                <el-form-item label="Note" prop="note">
                    <div class="form-value">{{data.note}}</div>
                </el-form-item>
                <el-form-item label="Created" prop="note">
                    <div class="form-value">{{data.created | formatDate}}</div>
                </el-form-item>
                <el-form-item v-if="userInfo.authenticate_id==data.authenticate_id">
                    <User2FaInputer :onInput="on2FaInput" :processing="processing" />
                </el-form-item>
            </el-form>

            <div
                slot="footer"
                class="dialog-footer"
                v-if="userInfo.authenticate_id==data.authenticate_id"
            >
                <el-button @click="onCancelClick">Close</el-button>
                <el-button @click="onDelete" type="danger" :disabled="!data.enabled">
                    <i class="el-icon-delete"></i> Disable
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import User2FaInputer from "./User2FAInputer";

export default {
    name: "MyAddressDetail",
    props: {
        data: Object,
        show: { default: false },
        onClose: Function
    },
    data() {
        return {
            processing: false,
            form: {
                auth2fa: "",
            }
        };
    },
    components: {
        User2FaInputer
    },
    computed: {
        ...mapState({
            userInfo: state => state.userInfo
        }),
    },
    methods: {
        ...mapActions(["request", "getError"]),
        on2FaInput(code) {
            this.form.auth2fa = code;
        },
        beforeClose(done = () => {}) {
            done();
        },
        onCancelClick(reload = false) {
            this.onClose(reload);
        },
        onDelete() {
            let ctrl = this;
            if (ctrl.data.disabled) {
                return;
            }
            ctrl.$confirm(
                "This address will be disabled permanently, Do you wish to continue?",
                "Disable Address",
                {
                    confirmButtonText: `Confirm`,
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            )
                .then(() => {
                    ctrl.processing = true;
                    ctrl.request({
                        method: "DELETE",
                        endpoint: `my/addressbook/${ctrl.data.id}`,
                        data: this.form
                    })
                        .then(() => {
                            this.$message({
                                message: "Address has been disabled",
                                type: "success"
                            });
                            ctrl.onCancelClick(true);
                        })
                        .catch(err => {
                            ctrl.getError({
                                err,
                                title: "ADDRESS_ERROR",
                                message: "Disable Address Failed"
                            }).then(ctrl.$notify);
                        })
                        .finally(() => {
                            ctrl.processing = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.form-value {
    font-weight: 600;
}
</style>
